import React from 'react'
import { Col, Row } from 'reactstrap'

const RSVWeeklyDetectionRate = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem1 right-padding6rem1 pb-md-5 pt-md-0 pt-4'>
            <div className=''>
                <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2'>
                    <center>Weekly Detection Rates</center>
                </div>
                <center>
                    <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                </center>
            </div>

            <div className='pt-md-5 pt-4'>
            <Row className='left-padding8rem1 right-padding8rem1 flex-center'>
                <Col md='6' className=''>
                    <img src='rsv-testing/RSV-Testing-stats1.png' alt='Weekly Detection Rates'  height='' width='' className='img-w8' />
                </Col>

                <Col md='6' className='pt-md-0 pt-4 pb-md-0 pb-5'>
                    <img src='rsv-testing/RSV-Testing-stats2.png' alt='Weekly Detection Rates'  height='' width='' className='img-w5-1' />
                </Col>
            </Row>
            </div>
        </div>
    </div>
  )
}

export default RSVWeeklyDetectionRate